<lib-modal-layout [title]="'Additional Insured Request'" [subtitle]="data.businessName + ' - ' + data.policyNumber">
    <h4 class="my-4 text-center">{{ data.typeOfEndorsement }}</h4>
    <p class="text-center my-4">
        The application for your Additional Insured request has been created. Download the application using the button
        below.
        <br />
        <br />
        This application must be reviewed and signed by the insured. When complete, upload the signed application to the
        documents section. This is required for an Affiliated Underwriter to review your additional insured request.
    </p>
    <div class="text-center" btnPrimary>
        <lib-button [cssType]="'btn-primary'" [text]="'Download Application'" [type]="'button'"
            (click)="downloadApplication()"></lib-button>
    </div>
</lib-modal-layout>